import React from 'react';
import { Chip, ChipCount, Chips } from '../PageSearch.styles';
import { ALL_SECTIONS_LABEL } from '../constants/pageSearch.constants';

const SectionChips = ({ chips, totalCount, section, getChipColor, onChange }) => (
	<Chips>
		<Chip active={!section} onClick={() => onChange('')}>
			{ALL_SECTIONS_LABEL}
			<ChipCount>{totalCount}</ChipCount>
		</Chip>
		{chips.map((chip) => (
			<Chip
				key={chip.section}
				color={getChipColor(chip.section)}
				active={chip.section === section}
				onClick={() => onChange(chip.section)}
			>
				{chip.section}
				<ChipCount>{chip.count}</ChipCount>
			</Chip>
		))}
	</Chips>
);

export default SectionChips;
